import { Injectable, Inject } from '@angular/core';
import { ApothekenService } from './interfaces/apotheken.service';
import { map } from 'rxjs/operators';
import { Observable, of, Subject, pipe } from 'rxjs';
import {
    Apotheke,
    ApothekenGruppe,
    ApothekenKooperation,
    AngebotsListe,
    Page,
} from 'src/app/shared/model';
import { HttpClient } from '@angular/common/http';
import { ApothekenAbstractService } from './interfaces/apotheken-abstract.service';
import { IndustriepartnerService } from './interfaces/industriepartner.service';
import { SERVICE_URL } from '../../../environments/tokens';
import {ApothekenFilter} from '../../shared/model/apotheke/apotheken-filter';

@Injectable()
export class ApothekenHttpService extends ApothekenAbstractService {
    private serviceUrl: string;
    private industriepartnerId = 'test-partner';

    zuweisungApotheken: Apotheke[] = [];
    zuweisungApothekenGruppen: ApothekenGruppe[] = [];
    zuweisungApothekenKooperationen: ApothekenKooperation[] = [];

    zuweisungApothekenSubject = new Subject<Apotheke[]>();
    zuweisungApothekenGruppenSubject = new Subject<ApothekenGruppe[]>();
    zuweisungApothekenKooperationenSubject = new Subject<
        ApothekenKooperation[]
    >();
    apothekenCountSubject = new Subject<number>();

    constructor(
        private http: HttpClient,
        private industriepartnerService: IndustriepartnerService,
        @Inject(SERVICE_URL) baseUrl: string
    ) {
        super();
        this.serviceUrl = baseUrl + 'apotheke';
    }

    getApothekenVonIndustriepartner(
        page: number,
        size: number,
        kooperation: ApothekenKooperation,
        gruppe: ApothekenGruppe,
        filter: ApothekenFilter
    ): Observable<Page<Apotheke>> {
        let urlFilter = new URLSearchParams();
        urlFilter.set('page', page.toString());
        urlFilter.set('size', size.toString());
        if(kooperation) {
          urlFilter.set('kooperationId', kooperation.id);
        }
        if(gruppe) {
          urlFilter.set('gruppeId', gruppe.id);
        }
        for(let key in filter) {
          urlFilter.set(key, filter[key]);
        }
        return this.http.get<Page<Apotheke>>(
            `${
                this.serviceUrl
            }/industriepartner/${this.industriepartnerService.getAnbieterNr()}?${urlFilter.toString()}`
        );
    }
    getApothekenGruppenVonIndustriepartner(): Observable<ApothekenGruppe[]> {
        return this.http.get<ApothekenGruppe[]>(`${this.serviceUrl}/gruppe/`);
    }
    getAllApothekenVonIndustriepartner(): Observable<Apotheke[]> {
        return this.http.get<Apotheke[]>(
            `${
                this.serviceUrl
            }/industriepartner/all/${this.industriepartnerService.getAnbieterNr()}`
        );
    }
    getApothekenKooperationenVonIndustriepartner(): Observable<
        ApothekenKooperation[]
    > {
        return this.http.get<ApothekenKooperation[]>(
            `${this.serviceUrl}/kooperation/`
        );
    }
    getApothekenCount(): Observable<number> {
        return this.apothekenCountSubject.asObservable();
    }

    processResultPage(page: Page<Apotheke>): Apotheke[] {
        this.apothekenCountSubject.next(page.totalElements);
        return page.content;
    }

    getIndustriepartnerVerfuegbareKooperationen() {
      return this.http.get(this.serviceUrl+'/industriepartner/'+this.industriepartnerService.getAnbieterNr()+'/filter/kooperationen');
    }

  getIndustriepartnerVerfuegbareGruppen() {
    return this.http.get(this.serviceUrl+'/industriepartner/'+this.industriepartnerService.getAnbieterNr()+'/filter/gruppen');
  }

  getBgaErrors(anbieterNummer) {
    return this.http.get(this.serviceUrl+'/bga-errors/', {params: {anbieterNummer: anbieterNummer}});
  }

  storeEditedBga(data) {
    return this.http.post(this.serviceUrl+'/bga-errors/edit', data);
  }
}
